<template>
    <ResourcePage v-if="collection" :theme="theme" class="collection-page">
        <template #header>
            <ResourcePageHero v-if="isNewResourcePageEnabled" :document="collection" />
            <SinglePageHero v-else :document="collection" :alternative-shapes="collection?.data?.useAlternativeHeroShapes" />
        </template>
        <template #main>
            <SliceZone :components="components" :slices="collection?.data?.slices ?? []" />
        </template>
    </ResourcePage>
</template>

<script lang="ts" setup>
    import {ref, inject, computed} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import type {CollectionDocument} from '@prismicio-types';
    import {useRoute} from '@typed-router';
    import {useAsyncData, useWebsitePageView} from '#imports';
    import {PRISMIC_DOCUMENT} from '~/app/keys';
    import ResourcePage from '~/components/ResourcePage.vue';
    import ResourcePageHero from '~/components/ResourcePageHero.vue';
    import SinglePageHero from '~/components/SinglePageHero.vue';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {components} from '~/slices/components';
    import {useFeatureFlagsStore} from '~/stores/feature-flags.store';

    const {features} = useFeatureFlagsStore();
    const isNewResourcePageEnabled = features['new-resource-page'];

    const {
        params: {uid},
    } = useRoute('resources-collection-uid');
    const prismicDocument = inject(PRISMIC_DOCUMENT, ref());
    const {data: collection} = await useAsyncData('collection', () => usePrismicDocument<CollectionDocument>('collection', uid as string), {
        deep: true,
    });
    prismicDocument.value = collection.value;

    const theme = computed(() => {
        if (collection.value?.data.theme) {
            return collection.value?.data.theme;
        }
        if (collection.value?.data.useAlternativeHeroShapes) {
            return 'corporate';
        }
        return 'default';
    });

    useWebsitePageView('resources-center', 'collections');
</script>

<style lang="scss">
    .collection-page .resource-page__main {
        max-width: 100%;
    }
</style>
